import { render, staticRenderFns } from "./reportSummary.vue?vue&type=template&id=60604213&scoped=true&"
import script from "./reportSummary.vue?vue&type=script&lang=js&"
export * from "./reportSummary.vue?vue&type=script&lang=js&"
import style0 from "./reportSummary.vue?vue&type=style&index=0&id=60604213&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60604213",
  null
  
)

export default component.exports